import React, {useRef} from "react";

import { Error } from "@churchofjesuschrist/eden-alert";
import {A11y} from "@churchofjesuschrist/eden-buttons";
import { Callout } from "@churchofjesuschrist/eden-callout";
import { Stack } from "@churchofjesuschrist/eden-stack";
import {spacing16} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import useProgramQuickSearch from "./use-program-quick-search";
import FilterTextInput from "../../generic/filter-text-input/filter-text-input";
import useOutsideClick from "../../generic/hooks/use-outside-click/use-outside-click";
import LoadingSpinner from "../../generic/loading/loading-spinner/loading-spinner";
import useManagedStrings from "../../utils/use-managed-strings";

const List = styled(Stack)`
padding:${spacing16};
min-width:300px;
`;
const LoadHolder = styled.div`
width:300px;`;

const stringGroups = [
  {
    name: "shared",
    keys: [
      "go",
      "invalidProgramNumber",
      "programNotFound",
      "searchByProgramNumber",
    ],
  },
];

const ProgramNumberSearch = ({
  onSearch = () => {},
  notFound = false,
}) => {
  const containerRef = useRef();
  const focusRef = useRef();
  const {
    query,
    onBlur,
    onChange,
    choices,
    status,
    onChoiceClicked,
    calloutOpen,
    clear,
    onKeyPress,
    onDismissError,
    hasError
  } = useProgramQuickSearch({onSearch, focusRef});

  // eslint-disable-next-line no-alert
  useOutsideClick(containerRef,clear);
  const {managedStrings} = useManagedStrings(stringGroups);
  return <div data-id="program-quick-search" ref={containerRef}>
    <FilterTextInput onChange={onChange}
      onBlur={onBlur}
      onKeyPress={onKeyPress}
      inputRef={focusRef}
      value={query}/>
    {calloutOpen && <Callout open={true} forRef={containerRef} onKeyPress={onKeyPress}>
      <List>
        {status.saving ? <LoadHolder><LoadingSpinner/></LoadHolder> :
          (status.error || hasError) ? <Error onClose={onDismissError}>{managedStrings.programNotFound}</Error> :
            choices && Array.isArray(choices) && choices.length > 0 ? choices.map(c => <div key={c.id}>
              <A11y onClick={() => onChoiceClicked(c)}>{c.programName}</A11y>
            </div>) : <div>{managedStrings.programNotFound}</div>
        }
      </List>
    </Callout>}
  </div>
}
/*return (
    <GenericSearch
      strings={useStrings}
      onSearch={onSearch}
      notFound={notFound}
      pattern="[0-9]{5}"
      alertSeconds={3}
      data-id="program-number-search"
    />
  );
};*/

export default ProgramNumberSearch;
